import NavigationService from "@utils/NavigationService";
import exit from "./exit";
// import analytics from "@services/analytics";
import { store } from "@store";
import { actions as snackbarActions } from "@reducers/snackbarReducer";
import { reportSupport } from "@services/api";
import t from "@constants/localization";

const PATH = "screens/SupportTree/utils";

const navigateToListOrItem = (item) => {
  const { support } = store.getState();
  const { ticketPayload } = support;

  const {
    nextAction,
    nextId,
    item_type,
    title = "",
    render = "",
    dataKey = "",
    dataValue = "",
    right_title_hi,
    query_item_id = "",
  } = item;
  if (nextAction === "EXIT" || item_type === "EXIT") {
    exit(item);
  } else {
    const nextRoute =
      nextAction === "GOTO_ITEM"
        ? "SupportItem"
        : nextAction === "GOTO_LIST"
          ? "SupportTree"
          : nextAction === "GOTO_SUPPORT_TICKETS"
            ? "SupportTickets"
            : nextAction === "ORDER_DETAILS"
              ? "OrderDetails"
              : nextAction === "REPORT"
                ? "ReportOption"
                : nextAction === "CHANGE_ADDRESS"
                  ? "LocationViaAddress"
                  : nextAction === "UPDATE_BANK_DETAILS"
                    ? "WithdrawMoney"
                    : nextAction === "CHANGE_KYC"
                      ? "KYCSetup"
                      : "";

    if (nextRoute === "ReportOption") {
      ReportOption(dataKey);
      return;
    }

    const dataKeys = [
      "DELIVERED_ORDERS",
      "TRACK_UNDELIVERED_ORDERS",
      "CANCEL_UNDELIVERED_ORDERS",
      "ORDER_LIST_V2",
      "PREPAID_DELIVERED_ORDERS",
      "RTO_ORDERS",
      "HAVENOT_RECEIVED_ORDERS",
    ];

    if (Array.isArray(ticketPayload) && ticketPayload.length !== 0) {
      const item_index = ticketPayload.findIndex((item) => {
        return (
          dataKeys.includes(item?.dataKey) && item?.render === "ORDER_ITEMS"
        );
      });
      if (item_index !== -1) {
        item_id = ticketPayload[item_index]?.value;
      } else {
        item_id = "";
      }
    } else {
      item_id = "";
    }

    const routeParams = {
      id: nextId,
      title,
      right_title_hi: right_title_hi || "",
      order_id: query_item_id || "",
      fromSupport: true,
      item_id: item_id ?? "",
    };

    NavigationService.push(nextRoute, routeParams, Date.now() + "");
  }
};

export default navigateToListOrItem;

const ReportOption = async (dataKey) => {
  const { data } = await reportSupport({ reportType: dataKey });
  const payload = {
    shouldShow: true,
    message: data?.message || "",
    position: "bottom",
    bottom: 0,
    autoHidingTime: 5000,
    autoHide: true,
    actionText: t(`${PATH}/okay`),
    actionHandler: (e) => {
      store.dispatch(snackbarActions.hideSnackbar());
    },
  };
  store.dispatch(snackbarActions.showSnackbar(payload));
  setTimeout(() => {
    store.dispatch(snackbarActions.hideSnackbar());
  }, 5000);
  NavigationService.reset({
    index: 1,
    routes: [
      {
        name: "Bottoms",
      },
      { name: "SupportTree" },
    ],
  });
};
